/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import initialState from 'store/initialState';

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState: initialState.configuration,
  reducers: {
    init: (state) => {
      state.list = [];
      state.error = '';
      state.loaded = false;
      state.loading = true;
    },
    error: (state, action) => {
      state.list = [];
      state.error = action.payload;
      state.loaded = true;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = '';
      state.loaded = false;
      state.loading = false;
    },
    success: (state, action) => {
      state.list = action.payload;
      state.error = '';
      state.loaded = true;
      state.loading = false;
    },
    clear: (state) => {
      state.list = [];
      state.error = '';
      state.loaded = false;
      state.loading = false;
    },
  },
});

export const configurationAction = configurationSlice.actions;

export default configurationSlice.reducer;
